export default __webpack_public_path__ + "static/media/ladies_garment.05c0ccac.png";